import Plan from '../../Constants/Plan';

export default function isVeryNice(plan) {
  return (
    plan?.id === Plan.VERY_NICE_2025.id || plan?.id === Plan.VERY_NICE_2023.id
  );
}
